<template>
  <div class="video-editor-container edyst-form-group fadeIn">
    <h2 class="text-center mb-4">
      {{ editMode ? "Update" : "Create" }} Video Question
    </h2>
    <label for="video url" class="w-full font-bold">Video URL</label>
    <div class="w-full">
      <input
        id="video url"
        v-model="videoURL"
        class="video-input-box"
        placeholder="Enter YouTube video URL"
        type="text"
        @input="getVideoID"
      />
    </div>
    <label for="name" class="w-full font-bold">Name</label>
    <div class="w-full">
      <input
        id="name"
        v-model="name"
        class="video-input-box"
        type="text"
        placeholder="Video Question Name (auto populated from video)"
      />
    </div>
    <label for="duration" class="w-full font-bold">Duration</label>
    <div class="w-full">
      <input
        id="duration"
        v-model="duration"
        class="video-input-box"
        type="text"
        placeholder="Duration (auto populated from video)"
      />
    </div>
    <div class="w-full font-bold">Tags</div>
    <div class="w-full mt-1">
      <VueSelect
        v-model="selectedTags"
        :options="tagOptions"
        label="name"
        multiple
      />
    </div>

    <label for="preview" class="w-full font-bold mt-3 mb-1 block"
      >Preview</label
    >
    <youtube :video-id="videoID" class="fadeIn" />
    <div class="text-right">
      <button
        class="button-blue px-4 py-2 rounded-sm"
        style="margin-bottom:30px;"
        @click="editVideo"
      >
        {{ editMode ? "Update" : "Add" }} Video
      </button>
    </div>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import { getIdFromURL } from "vue-youtube-embed"
import siteConfig from "@/utils/siteConfig"

export default {
  components: { VueSelect },
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      videoURL: "",
      videoID: "",
      is_required: false,
      is_bonus: false,
      name: "",
      tagOptions: [],
      selectedTags: [],
      duration: 0,
      qtags: [],
    }
  },
  created() {
    if (this.editMode) {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}questions/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          const videoObj = res.data.data
          this.videoURL = videoObj.content
          this.is_required = videoObj.is_required
          this.name = videoObj.name
          window.pageTitle = `Edit - ${this.name}`
          this.is_bonus = videoObj.is_bonus
          this.qtags = videoObj.qtags
          this.selectedTags = this.qtags.map(item => ({
            id: item.id,
            name: item.name,
          }))
          this.getVideoID()
          this.fetchTags()
        })
        .catch(err => {
          this.$noty.error(`Failed to fetch video details`)
          console.error(err)
        })
    } else {
      this.fetchTags()
    }
  },
  methods: {
    updateVideoInfoFromYouTubeAPI() {
      this.axios({
        method: "get",
        url: `https://www.googleapis.com/youtube/v3/videos?id=${this.videoID}&key=AIzaSyAGcphfyXaav-WYeLnWcuVLVdEVqa3HLQk&part=snippet,contentDetails`,
      })
        .then(res => {
          const { title } = res.data.items[0].snippet
          const duration = this.YTDurationToSeconds(
            res.data.items[0].contentDetails.duration
          )
          this.name = title
          this.duration = duration
        })
        .catch(err => {
          this.$noty.error(`Failed to fetch tags`)
          console.error(err)
        })
    },
    YTDurationToSeconds(duration) {
      let match = duration.match(/PT(\d+H)?(\d+M)?(\d+S)?/)

      match = match.slice(1).map(x => {
        if (x) {
          return x.replace(/\D/, "")
        }
        return x
      })

      const hours = parseInt(match[0]) || 0
      const minutes = parseInt(match[1]) || 0
      const seconds = parseInt(match[2]) || 0

      return hours * 3600 + minutes * 60 + seconds
    },
    getDeletedTags() {
      const deletedTags = []
      for (let i = 0; i < this.qtags.length; i++) {
        if (
          !this.findElementInArray(
            this.qtags[i].name,
            this.selectedTags.map(item => item.name)
          )
        ) {
          deletedTags.push(this.qtags[i])
        }
      }
      const finalTags = []
      for (let i = 0; i < deletedTags.length; i++) {
        finalTags.push(deletedTags[i].id)
      }
      return finalTags
    },
    getAddedTags() {
      const addedTags = []

      for (let i = 0; i < this.selectedTags.length; i++) {
        if (
          !this.findElementInArray(
            this.selectedTags[i].name,
            this.qtags.map(item => item.name)
          )
        ) {
          addedTags.push(this.selectedTags[i])
        }
      }
      const finalTags = []
      for (let i = 0; i < addedTags.length; i++) {
        finalTags.push(addedTags[i].id)
      }
      return finalTags
    },
    findElementInArray(element, array) {
      for (let i = 0; i < array.length; i++) {
        if (array[i] === element) {
          return true
        }
      }
      return false
    },
    fetchTags() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}qtags/?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          const tags = res.data.items
          this.tagOptions = tags.map(item => ({ id: item.id, name: item.name }))
        })
        .catch(err => {
          this.$noty.error("Failed to tag options")
          console.error(err)
        })
    },
    getVideoID() {
      this.videoID = getIdFromURL(this.videoURL)
      this.updateVideoInfoFromYouTubeAPI()
    },
    validateYouTubeURL(url) {
      const p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/
      const matches = url.match(p)
      if (matches) {
        return true
      }
      return false
    },
    editVideo() {
      if (this.name.length <= 2) {
        this.$noty.error("Please make sure the video name is not blank")
        return
      }
      if (!this.validateYouTubeURL(this.videoURL)) {
        this.$noty.error("invalid URL")
        return
      }

      const qObject = {
        answers: "",
        content: this.videoURL,
        reading_time: this.duration,
        tries: 0,
        points: 0,
        name: this.name,
        is_required: this.is_required,
        type: 4, // / 4 is video
        item_cursor: 0,
        is_dependent_ids: "[]",
        attachments: {},
        ops_qtags_unlink: this.getDeletedTags(),
        ops_qtags: this.getAddedTags(),
        is_bonus: this.is_bonus,
      }

      const url = this.editMode
        ? `${siteConfig.siteURL}questions/${this.$route.params.id}`
        : `${siteConfig.siteURL}questions/`
      this.axios({
        method: this.editMode ? "put" : "post",
        url,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: qObject,
      })
        .then(() => {
          this.$router.push("/video")
        })
        .catch(err => {
          this.$noty.error(
            `Failed to ${this.editMode ? "update" : "create"} video`
          )
          console.error(err)
        })
    },
  },
}
</script>

<style>
.video-editor-container {
  max-width: 65rem;
  margin: auto;
}

.video-editor-container.edyst-form-group input[type="text"] {
  margin-top: 0.3rem;
}

.video-input-box {
  width: 100%;
  margin-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.4);
}
</style>
